import styled from 'styled-components';
import { black, newMark, warningred, white } from 'styles/Colors';

export const TeamSelectorWrapper = styled.div`
  margin-top: 5px;
  ::placeholder {
    color: ${black};
    opacity: 0.35;
  }
  .react-autosuggest__container {
    position: relative;

    label {
      border-bottom: none;
    }
  }
  .react-autosuggest__input {
    width: 100%;
    font-family: Lato, sans-serif;
    font-size: 15px;
    letter-spacing: 0.5px;
    line-height: 15px;
    color: rgb(34, 34, 34);
    border-top-style: initial;
    border-right-style: initial;
    border-left-style: initial;
    border-top-color: initial;
    border-right-color: initial;
    border-left-color: initial;
    border-width: 0px 0px 1px;
    border-image: initial;
    outline: 0px;
    background: 0px center;
    border-bottom: none;
    &::placeholder {
      color: rgb(34, 34, 34);
      opacity: 0.7;
    }
    &:disabled {
      &::placeholder {
        opacity: 0.3;
      }
    }
  }

  .react-autosuggest__input--focused {
    outline: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    top: 51px;
    width: 100%;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
    background-color: ${white};
    font-family: Helvetica, sans-serif;
    z-index: 2;
  }

  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    max-height: 400px;
    overflow-y: scroll;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 8px 15px;
    p {
      margin: 0;
      padding: 0;

      color: #414141;
      font-family: Lato;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18.2px;
    }
    mark {
      padding: 0;
      background-color: ${newMark};
    }
  }

  .react-autosuggest__suggestion--highlighted {
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  }

  .selected-team {
    display: table-cell;
    svg {
      vertical-align: bottom;
      margin-left: 10px;
      width: 36px;
      height: 36px;
      path {
        fill: ${warningred};
      }
    }
  }
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
